{
  "API_URL": "http://localhost:4000",
  "AUTH0_AUDIENCE": "https://ansvar-sakerhet.production.com",
  "AUTH0_DOMAIN": "ansvarsakerhet-production.eu.auth0.com",
  "AUTH0_CLIENT_ID": "bIDWmkFu01ADcakNmEfNf2SoJwVjuHnE",
  "ENABLE_PERSONDATA_REPORT_TEXT_GENERATION": true
}
